module.exports = __webpack_public_path__ + "static/PRO002Banner-777aa75cd02025f03647d2c5edd29c23.jpg";